import React, { useCallback } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import ProcesosEmpresaWorkflowsModal from './ProcesosEmpresaWorkflowsModal';
import {
  parseProcesosEmpresaId,
  procesosEmpresasPath,
  procesosEmpresaWorkflowPeriodosPath,
  type ProcesosEmpresaLocationState,
} from './procesos-empresa-routes';
import { readProcesosReturnSearch } from './procesos-workflow-routes';

export default function ProcesosEmpresaWorkflowsModalRoute() {
  const navigate = useNavigate();
  const location = useLocation();
  const { empresaId: empresaIdParam } = useParams();
  const state = location.state as ProcesosEmpresaLocationState | null;
  const procesosReturnSearch = readProcesosReturnSearch(state);
  const returnPath = state?.returnPath || '/procesos';
  const empresaId = parseProcesosEmpresaId(location.pathname)
    ?? (Number(empresaIdParam) > 0 ? Number(empresaIdParam) : null);

  const handleClose = useCallback(() => {
    navigate(`${returnPath}${procesosReturnSearch}`);
  }, [navigate, procesosReturnSearch, returnPath]);

  const handleBack = useCallback(() => {
    navigate(procesosEmpresasPath(procesosReturnSearch), {
      state: { procesosSearch: procesosReturnSearch, returnPath },
    });
  }, [navigate, procesosReturnSearch, returnPath]);

  const handleSelectWorkflow = useCallback((workflow: { id: number; nombre?: string }) => {
    if (empresaId == null) return;
    navigate(procesosEmpresaWorkflowPeriodosPath(empresaId, workflow.id, procesosReturnSearch), {
      state: {
        procesosSearch: procesosReturnSearch,
        returnPath,
        empresaLabel: state?.empresaLabel,
        workflowNombre: workflow.nombre,
      },
    });
  }, [empresaId, navigate, procesosReturnSearch, returnPath, state?.empresaLabel]);

  if (empresaId == null) return null;

  return (
    <ProcesosEmpresaWorkflowsModal
      open
      empresaId={empresaId}
      empresaLabel={state?.empresaLabel}
      onClose={handleClose}
      onBack={handleBack}
      onSelectWorkflow={handleSelectWorkflow}
    />
  );
}
